import { useEffect } from "react"

/**
 * Счётчик несохранённых правок текущего экрана.
 *
 * Нужен шапке: смена языка пересоздаёт содержимое (`<Outlet key={languageId}>`),
 * и всё несохранённое пропало бы молча. Экран сообщает своё число сюда, шапка
 * перед переключением спрашивает.
 *
 * Экран на странице один, поэтому и счётчик один — стека не нужно.
 */
let unsaved = 0

export function useUnsaved(count: number): void {
	useEffect(() => {
		unsaved = count
		return () => {
			unsaved = 0
		}
	}, [count])
}

/** true — можно продолжать; false — пользователь передумал. */
export function confirmDiscard(action: string): boolean {
	if (unsaved === 0) return true
	return window.confirm(`Не сохранено правок: ${unsaved}. ${action}`)
}
